import handler from 'api/handler'

const prefix = '/admin/settings'

const methods = {
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  updateMembershipFees: args => handler({ method: 'put', url: prefix + '/updateMembershipFees', args })
}

export default methods


